import { ref } from 'vue'

import type { CartItem } from '@backmarket/nuxt-layer-checkout/api/cart/types'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import type { ListingsPopularityStats } from '~/api/checkout/popularity-stats/types'

export function usePopularityStats() {
  const $httpFetch = useHttpFetch()
  const popularityStats = ref<ListingsPopularityStats[]>([])

  async function fetchPopularityStats(items: Array<CartItem>) {
    if (items.length) {
      popularityStats.value = await $httpFetch(
        '/api/popularity-stats/v2/listings/tags/',
        {
          query: {
            listing_ids: items.map((item) => item.listingPublicId).join(','),
          },
        },
      )
    }
  }

  const getItemPopularityStats = (item: CartItem) =>
    popularityStats.value.find((popularityItem) => {
      return popularityItem.listingPublicId === item.listingPublicId
    })

  const hasPopularityStats = (item: CartItem) => !!getItemPopularityStats(item)

  return { fetchPopularityStats, getItemPopularityStats, hasPopularityStats }
}
